import * as React from 'react';
import injectSheet from 'react-jss';
import { useGenericState } from 'src/Library/UseGenericState';
import { Form, Modal, message } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import { UploadChangeParam } from 'antd/lib/upload';

import { ExcelS3UploadInterfaceProps } from './ExcelS3Upload.types';
import { ExcelS3UploadHtml } from './ExcelS3Upload.html';
import Styles from './ExcelS3Upload.styles';
import useS3Upload from 'src/hooks/useS3Upload';
import { useModel } from './ExcelS3Upload.model';

const ExcelS3Upload: React.FC<ExcelS3UploadInterfaceProps> = (props) => {
  const model = useModel(props);

  return <ExcelS3UploadHtml model={model} />;
};

export default injectSheet(Styles)(ExcelS3Upload);
